// extracted by mini-css-extract-plugin
module.exports = {"dictionaryContainer":"styles_dictionaryContainer__ZUv6O","header":"styles_header__3DZ08","label":"styles_label__2hL1E","dictionary":"styles_dictionary__2DQi-"};